export default __webpack_public_path__ + "static/media/single-swipe.ef0e9ea1.png";